import React from 'react';
import { Package, Tag, Split, Eye, Pin, Edit, TrendingUp, RotateCcw, Inbox, Send, Search, FileText, Database, GitCompareArrows, ClipboardList, PackageMinus, ClipboardCheck } from 'lucide-react';
import SectionDashboard from '../SectionDashboard';
import { moduleReportTiles } from '@/lib/sectionModules';

const GreigeDashboard = () => {
  // Greige-specific operations (7 sequential operations)
  const operations = [
    {
      id: 'bundle-receipt',
      title: 'Bundle Receipt Entry',
      description: 'Verify and receive bundles from consignments',
      icon: Package,
      route: '/sections/greige/bundle-receipt',
      color: 'bg-blue-500'
    },
    {
      id: 'sort-assignment',
      title: 'Sort No Assignment',
      description: 'Assign vendor, sort no, color to bundles',
      icon: Tag,
      route: '/sections/greige/sort-assignment',
      color: 'bg-blue-500'
    },
    {
      id: 'bundle-split',
      title: 'Multiple Bundle Split',
      description: 'Split bundle into multiple new bundles',
      icon: Split,
      route: '/sections/greige/bundle-split',
      color: 'bg-purple-500'
    },
    {
      id: 'inspection',
      title: 'Greige Inspection',
      description: 'Record bundle damages (qty assigned later at Reconcile)',
      icon: Eye,
      route: '/sections/greige/inspection',
      color: 'bg-orange-500'
    },
    {
      id: 'legacy-bundle-backfill',
      title: 'Legacy - Bulk Bundle Backfill (CSV)',
      description: 'Mark completed legacy bundles via CSV — no dummy scans',
      icon: Database,
      route: '/sections/greige/legacy-bundle-backfill',
      color: 'bg-amber-600'
    },
    {
      id: 'pinning',
      title: 'Pinning',
      description: 'Record pinning work by staff',
      icon: Pin,
      route: '/sections/greige/pinning',
      color: 'bg-pink-500'
    },
    {
      id: 'marker-writing',
      title: 'Marker Writing',
      description: 'Record marker writing work by staff',
      icon: Edit,
      route: '/sections/greige/marker-writing',
      color: 'bg-cyan-500'
    },
    {
      id: 'packing',
      title: 'Packing',
      description: 'Record packing work by staff',
      icon: Package,
      route: '/sections/greige/packing',
      color: 'bg-teal-500'
    },
    {
      id: 'reconcile',
      title: 'Reconcile Operation',
      description: 'Confirm document qty & assign USNs before Internal Transfer',
      icon: GitCompareArrows,
      route: '/sections/greige/reconcile',
      color: 'bg-violet-500'
    }
  ];

  // Greige-specific utilities
  const utilities = [
    {
      id: 'supplier-returns',
      title: 'Supplier Returns',
      description: 'Send back goods received without a PO or above the PO — approve and print the Return Challan',
      icon: PackageMinus,
      route: '/sections/greige/supplier-returns',
      color: 'bg-amber-700',
      testId: 'supplier-returns-tile'
    },
    {
      id: 'grn',
      title: 'Goods Receipt Notes',
      description: 'Finalise the GRN of a supplier delivery once its bundles are counted on the PO',
      icon: ClipboardCheck,
      route: '/po/grn',
      color: 'bg-emerald-700',
      testId: 'grn-tile'
    },
    {
      id: 'bundle-usn-trace',
      title: 'Bundle / USN Trace',
      description: 'Universal search — bundle or USN lifecycle report',
      icon: Search,
      route: '/sections/greige/trace',
      color: 'bg-emerald-600'
    },
    {
      id: 'bundle-detail-report',
      title: 'Bundle Detail Report',
      description: 'Supplier, sort no, color & bundle no — date + universal filter',
      icon: FileText,
      route: '/sections/greige/bundle-detail-report',
      color: 'bg-emerald-500'
    },
    {
      id: 'documents-report',
      title: 'Documents Report',
      description: 'All received documents — status, date range & universal search',
      icon: ClipboardList,
      route: '/sections/greige/documents-report',
      color: 'bg-emerald-700'
    },
    {
      id: 'reconcile-report',
      title: 'Reconcile Report',
      description: 'Reconciled documents — date range, universal search, print & CSV',
      icon: GitCompareArrows,
      route: '/sections/greige/reconcile-report',
      color: 'bg-violet-600'
    },
    {
      id: 'staff-performance',
      title: 'Staff Performance',
      description: 'View productivity and work metrics',
      icon: TrendingUp,
      route: '/sections/greige/staff-performance',
      color: 'bg-amber-500'
    },
    {
      id: 'usn-reprint',
      title: 'USN Reprint',
      description: 'Reprint damaged or missing USN stickers',
      icon: RotateCcw,
      route: '/sections/greige/usn-reprint',
      color: 'bg-indigo-500'
    }
  ];

  return (
    <SectionDashboard
      sectionName="Greige Section"
      sectionId="greige"
      sectionKey="Greige"
      description="Operations Dashboard"
      backRoute="/dashboard"
      operations={operations}
      utilities={[...utilities, ...moduleReportTiles('greige', { docs: false })]}
    />
  );
};

export default GreigeDashboard;
